import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useAccount } from "PFCore/hooks/queries/accounts/use_account";
import { useFeatures, useToggleFeatures } from "PFCore/hooks/queries/features/use_features";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import FeaturesListPage from "./features_list_page";

const FeaturesListController = (): JSX.Element => {
  const { t } = useTranslation("saasAdmin");

  const { accountId } = useParams<{ accountId: string }>();
  const [currentPage, setCurrentPage] = React.useState(1);

  const { features, isLoading, totalPages, error } = useFeatures({
    accountId: Number(accountId),
    currentPage
  });

  const { mutate } = useToggleFeatures({
    accountId: Number(accountId),
    currentPage
  });

  const { data: accountData } = useAccount({ accountId: Number(accountId) });

  const WrappedFeaturesListPage = usePageWrapper(FeaturesListPage);

  return (
    <WrappedFeaturesListPage
      loading={isLoading}
      errorComponent={
        <NotFoundComponent
          message={t("accounts.features.error.notFoundMessage")}
          buttonMessage={t("accounts.features.error.buttonMessage")}
          buttonUrl="/sass_admin/features"
        />
      }
      errors={error ? [error] : []}
      features={features}
      toggleFeature={mutate}
      accountName={accountData?.name ?? ""}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      totalPages={totalPages}
    />
  );
};

export default FeaturesListController;
